// Color threshold defaults: value >= high → green, value >= mid → yellow, else → red
export const DEFAULT_THRESHOLDS = { high: 50, mid: 10 };
